module.exports = __webpack_public_path__ + "img/logo-white.9b048930.png";